// extracted by mini-css-extract-plugin
export var arrowbtn = "carousel_fixed-module--arrowbtn--a6cfe";
export var autoscroll = "carousel_fixed-module--autoscroll--1a293";
export var bleed = "carousel_fixed-module--bleed--f9911";
export var carousel = "carousel_fixed-module--carousel--d4990";
export var carousel_wr = "carousel_fixed-module--carousel_wr--bc93c";
export var fig = "carousel_fixed-module--fig--cf54d";
export var fixed_car = "carousel_fixed-module--fixed_car--bd36e";
export var forw = "carousel_fixed-module--forw--27427";
export var img = "carousel_fixed-module--img--0373f";
export var off = "carousel_fixed-module--off--f8ae7";
export var on = "carousel_fixed-module--on--6e5ef";
export var scroll = "carousel_fixed-module--scroll--21845";
export var titles = "carousel_fixed-module--titles--3c2dd";
export var usingKeyboard = "carousel_fixed-module--using-keyboard--d7436";